let timer
export default (func, wait) => {
  clearTimeout(timer)
  // eslint-disable-next-line testing-library/await-async-utils
  timer = setTimeout(func, wait)
}
